/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import FacebookLogin from '@greatsumini/react-facebook-login';
import { radiusEndpointBase } from '../../../constants/Endpoint';
import { Button } from 'reactstrap';
import { useContext } from 'react';
import { LoginContext } from '../../../Context';

const facebookAppId = "638703235130485";

const FacebookLoginButton = (props) => {
  const loginContext = useContext(LoginContext);
  const currentUrl = window.location.href;
  const lastSlashIndex = currentUrl.lastIndexOf("/");
  const urlStrippedRoute = currentUrl.substring(0, lastSlashIndex);
  const urlVerifyRoute = urlStrippedRoute + "/verify";

  const endpointBase = loginContext.config?.dashboardDomain ? `https://${loginContext.config?.dashboardDomain}:8080/` : radiusEndpointBase;
  const redirect = `${endpointBase}facebook/guest/callback`;
  const customFacebookAppId = loginContext.config?.facebookConfig?.clientId;

  return (
    <FacebookLogin
      appId={customFacebookAppId ?? facebookAppId}
      useRedirect={true}
      scope='public_profile,email,user_birthday'
      dialogParams={{
        response_type: 'code',
        redirect_uri: redirect,
        state: JSON.stringify({
          redirect_url: urlVerifyRoute
        })
      }}
      render={({onClick}) => (
        <Button {...props} onClick={onClick} />
      )}
    />
  );
};

export default FacebookLoginButton;
